module.exports = "<div class=\"input-wrapper\"\n    [class.focused]=\"isFocused\">\n\n  <textarea #message autosize rows=1 placeholder=\"Write a message...\" (input)=\"didInput()\" (focus)=\"doFocus()\" (blur)=\"doBlur()\"></textarea>\n\n  <div class=\"right-wrapper\" (click)=\"didSubmit(message)\">\n    <clr-icon shape=\"caret right\"></clr-icon>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/common/input-bar/input-bar.component.html
// module id = ../../../../../src/app/common/input-bar/input-bar.component.html
// module chunks = main